export default {
    delivery: {
        product: {
            tracking: "Suivi",
            quantity: "Quantité"
        }
    }
}